import api from '../config/axios-conf';

export const getServices = (params) =>
    api.get('/services/serviceAll', { params });

export const searchServices = (name) =>
    api.get('/services/search', { params: { name } });

export const getServiceDetail = (id) =>
    api.get(`/services/detail/${id}`);

export const getServiceVariants = (id) =>
    api.get(`/services/variant/${id}`);

export const createService = (data) =>
    api.post('/services/create', data);

export const updateService = (id, data) =>
    api.put(`/services/update/${id}`, data);

export const deleteService = (id) =>
    api.delete(`/services/${id}`);

export const getCategoriesByType = (type) =>
    api.get(`/services/categoryByType/${type}`);

export const createCategory = (data) =>
    api.post('/services/category', data);

export const updateCategory = (id, data) =>
    api.put(`/services/category/${id}`, data);

export const deleteCategory = (id) =>
    api.delete(`/services/category/${id}`);

export const getAttributes = () =>
    api.get('/services/attributeAll');

export const createAttribute = (data) =>
    api.post('/services/attribute', data);

export const updateAttribute = (id, data) =>
    api.put(`/services/attribute/${id}`, data);

export const deleteAttribute = (id) =>
    api.delete(`/services/attribute/${id}`);

export const getAttributeValues = (attributeId) =>
    api.get(`/services/attributeValueAll/${attributeId}`);

export const createAttributeValue = (data) =>
    api.post('/services/attributeValue', data);

export const updateAttributeValue = (id, data) =>
    api.put(`/services/attributeValue/${id}`, data);

export const deleteAttributeValue = (id) =>
    api.delete(`/services/attributeValue/${id}`);

export const createVariant = (data) =>
    api.post('/services/variant', data);

export const updateVariant = (id, data) =>
    api.put(`/services/variant/${id}`, data);

export const updateVariantAttributes = (variantId, attributeValueIds) =>
    api.put(`/services/variant/${variantId}/attributes`, { attributeValueIds });

export const uploadImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const updateCombo = (id, data) =>
    api.put(`/services/combo/${id}`, data);

export const createGroup = (data) =>
    api.post('/services/group', data);

export const deleteGroup = (serviceId, categoryId) =>
    api.delete(`/services/group/${serviceId}/${categoryId}`);
